import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorSurface } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const layout = css`
  &.LayoutPage {
    background-color: ${base_colorSurface};
    overflow-y: auto;

    .content {
      overflow: visible;
    }
  }
`

export const pageContent = css`
  box-sizing: border-box;
  min-height: 100%;
  padding: ${spacing(6)} ${spacing(8)} ${spacing(16)};
  width: 100%;

  ${getBreakpointDown(breakpointSizes.XSM)(css`
    padding: ${spacing(4)};
  `)}
`
